{
  "Image upload": "Bilduppladdning",
  "Image": "Bild",
  "Image preview": "Förhandsvisning",
  "file-upload": "Filuppladdning",
  "help-image": "Bara PNG eller JPG — <0>(Max storlek 4 MB och minsta dimensioner 1280x720)</0>",
  "help-resource": "<0>Max storlek 200 MB</0>",
  "help-audio": "Endast MP3 — <0>(Max storlek 200 MB)</0>",
  "help-e-learning": "Endast HTML5 e-learning ZIP — <0>(Max storlek 1 GB)</0>",
  "Select file": "Välj fil",
  "file-too-large": "Filen är för stor.",
  "image-upload-space": "Du behöver välja ett utrymme först.",
  "image-dimension-validation-fail": "Bilden följer inte minsta tillåtna dimensionerna (minsta dimensioner 1280x720).",
  "File preview": "Förhandsvisa",
  "image-upload-success": "Uppladdningen lyckades",
  "image-upload-success_discussion": "Uppladdningen lyckades. Spara inlägget för att behålla bilden.",
  "image-upload-success_admin": "Uppladdningen lyckades. Spara för att behålla bilden.",
  "file-upload-success": "Uppladdningen lyckades. Spara för att behålla filen.",
  "Remove media": "Ta bort fil",
  "PDF": "PDF",
  "Video": "Videolänk",
  "Cannot upload file - product does not belong to a space": "Kunde inte ladda upp fil. Produkten tillhör inte ett område.",
  "Video preview": "Förhandsvisa",
  "Embed external video": "Lägg till",
  "URL": "Videolänk",
  "Video embed URL": "Lägg in video-URL här",
  "upload-reset-space": "Bilden eller filen du laddade upp togs bort på grund av byte av utrymme",
  "image-size-limit-error": "Image is too large. Only .png and .jpg (Maximum size 4 MB)"
}
